export class IApplicant{
  id?: number | null = null;
  name: string = "";
  profession: string = "";
  academicLevel: string= "";
  graduateId?: number | null = null;
}